import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Form, Input, Button, message, Spin  } from 'antd';
import {UserOutlined , LockOutlined, LoadingOutlined} from '@ant-design/icons';
import {loginUser} from '../../../_actions/chatbot_actions';
import { useDispatch } from "react-redux";
import './login.css';
import crypto from 'crypto-js';

export default function LoginPage(props) {

  const dispatch                = useDispatch();
  const [ID, setID]             = useState("")
  const [Password, setPassword] = useState("")
  const [Spining, setSpining] = useState(false)

  const navigate = useNavigate();
  useEffect(() => {
    localStorage.clear();
  }, [])
  
  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 24
      }}
      spin />
  )
  const onIDHandler = (event) => {
    setID(event.currentTarget.value);
  }

  const onPasswordHandler = (event) => {

    try {
         const ciphertext = crypto.HmacSHA512(event.currentTarget.value, 'ecoSalt1').toString();
         setPassword(ciphertext);
    } catch (e) {
        console.error(e);
    }
  }

  const onSubmitHandler = (event) => {
    event.preventDefault();

    const dataToSubmit = {
      'adminId' : ID,
      'adminPw' : Password
    }

  dispatch(loginUser(dataToSubmit))
  .then(async(response) => {


    setSpining(true);
    const code = response.payload.code;
    
    if(code==='Y') {
      message.info('로그인 성공');
      const adminToken = response.payload.data.adminToken;
      const adminInfo = response.payload.data.adminInfo;

      window.localStorage.setItem('adminToken', adminToken);
      window.localStorage.setItem('manageCode', adminInfo.manage_code );
      window.localStorage.setItem('id', adminInfo.admin_id );
      
      setTimeout(() => {
        setSpining(false);
        return navigate('/chatbot');
      }, 1000);
    } else {
      message.info('로그인 실패');
      setSpining(false);
      return navigate('/');
    }
  })

  }

  return (
    <div>
    
    {/* <Carousel autoplay>
    <div>
      <h3>반갑습니다 !!!</h3>
    </div>
    <div>
      <h3>챗봇 백오피스 접속을 위해</h3>
    </div>
    <div>
      <h3>로그인 해주세요.</h3>
    </div>
  </Carousel> */}

    <div style={{ display:'flex', justifyContent:'center', alignItems: 'center', height: '90.8vh'}}>
    <Spin indicator={antIcon} spinning={Spining}>
      <Form onSubmit={onSubmitHandler} className="login-form">
          <Form.Item>
              <Input
                prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                onChange={onIDHandler}
                placeholder="아이디"
              />
          </Form.Item>
          <Form.Item>
              <Input
                prefix={ <LockOutlined   style={{ color: 'rgba(0,0,0,.25)' }}/>}
                onChange={onPasswordHandler}
                type="password"
                placeholder="패스워드"
              />
          </Form.Item>
          <Form.Item>
            <Button onClick={onSubmitHandler} type="primary" htmlType="submit" className="login-form-button" style={{width: 187.047}}>
              로그인
            </Button>
          </Form.Item>
          <Form.Item>
            <Button onClick={() => {message.info('준비중')}} type="dashed" htmlType="submit" className="login-form-button" style={{width: 187.047}}>
              회원 가입
            </Button>
          </Form.Item>
          <Link to={"/"}>뒤로가기</Link>
        </Form>
      </Spin>
    </div>
  </div>
  );
};


